<template>
  <div class="container">
    <b-row>
      <b-col class="m-3">
        <b-card class="w-100 shadow" :title="isAdd ? 'ایجاد منبع' : 'ویرایش منبع'">
          <b-overlay :show="loading" rounded opacity="0.6" spinner-large spinner-variant="info"
            class="d-inline-block w-100" @hidden="!loading">
            <label for="input_contentTitle" class="text-right w-100 required-label">عنوان</label>
            <b-form-input type="text" v-model="reference.content_title" id="input_contentTitle"
              placeholder="ورود عنوان منبع" class="rtl"></b-form-input>

            <label for="input_heldAt" class="mt-3 text-right w-100 required-label">تاریخ برگزاری</label>
            <b-row>
              <b-col>
                <persian-datetime-picker type="date" v-model="reference.held_at" format="x"
                  display-format="jYYYY/jMM/jDD" placeholder="انتخاب تاریخ" color="#00acc1"></persian-datetime-picker>
              </b-col>
              <b-col class="text-center">
                {{ reference.formated_jalali_held_at }}
              </b-col>
            </b-row>

            <p class="mt-3 text-right w-100">متن</p>
            <ckeditor :editor="ckeditor.editor" v-model="reference.content" :config="ckeditor.editorConfig"></ckeditor>

            <p class="mt-3 text-right w-100" v-show="!isAdd">آپلود فایل متن</p>
            <b-form-file v-show="!isAdd" class="text-center" v-model="referenceDetailFile" multiple
              drop-placeholder="اینجا رها کنید" placeholder="فایلی را انتخاب کنید یا در اینجا رها کنید"
              browse-text="انتخاب فایل" @input="uploadReferenceDetailFile"></b-form-file>

            <p class="mt-3 text-right w-100">آپلود ضمیمه</p>
            <b-form-file class="text-center" v-model="inputAttachmentFiles" multiple drop-placeholder="اینجا رها کنید"
              placeholder="فایلی را انتخاب کنید یا در اینجا رها کنید" browse-text="انتخاب فایل"
              @input="uploadAttachmentFiles"></b-form-file>
            <b-list-group :key="attachmentFilesKey" v-if="
              Array.isArray(attachmentFiles) && attachmentFiles.length > 0
            " class="mt-2">
              <b-list-group-item v-for="(attachmentFile, index) in attachmentFiles" :key="index"
                class="p-2 rtl text-right" :disabled="!attachmentFile.url">
                <b-img v-show="
                  attachmentFile.mimeType &&
                  attachmentFile.mimeType.startsWith('image')
                " :src="attachmentFile.url" thumbnail fluid class="w-25"></b-img>
                <a :href="attachmentFile.url" class="d-block w-100 ltr text-center" target="_blank"
                  rel="noopener noreferrer">{{ attachmentFile.originalName }}</a><br />
                {{ attachmentFile.desc }}
                <b-button pill variant="outline-danger" size="sm" @click="dropAttachment(index)">
                  <b-icon icon="trash"></b-icon>
                </b-button>
              </b-list-group-item>
            </b-list-group>

            <b-button v-if="!isAdd" variant="outline-danger" size="sm" class="mt-5 d-block" @click="doRemove"
              :disabled="loading">
              <b-icon icon="trash" class="m-1"></b-icon>حذف یا مخفی
              کردن
            </b-button>

            <b-button variant="info" class="mx-auto w-25 mt-3" @click="doAddOrEdit" :disabled="loading">
              <span v-if="isAdd">ایجاد</span>
              <span v-else>ثبت</span>
            </b-button>
            <b-button variant="outline-info" class="mx-auto mt-3" @click="$router.go(homeIndex)" :disabled="loading">
              بازگشت
            </b-button>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import humanize from "../../utils/humanize";
import _ from "lodash";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import momentJalaali from "moment-jalaali";

export default {
  name: "ReferenceAddEdit",
  data: () => ({
    ckeditor: {
      editor: ClassicEditor,
      editorConfig: {
        contentsLangDirection: "rtl",
        language: "fa"
      },
    },
    loading: false,
    isAdd: true,
    homeIndex: -1,
    reference_id: null,
    reference: {
      content_title: "",
      content: "",
      is_hidden: false,
      attachments: [],
      held_at: Date.now(),
    },
    //file inputs
    referenceDetailFile: null,
    inputAttachmentFiles: [],
    attachmentFiles: [],
    attachmentFilesKey: 0,
  }),
  created() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      if (this.$route.query.home_index) {
        this.homeIndex = parseInt(this.$route.query.home_index);
      }

      //populate ui for edit
      this.reference_id = this.$route.params.reference_id;
      if (this.reference_id) {
        this.isAdd = false;

        this.loading = true;
        this.$axios
          .get("/references/" + this.reference_id)
          .then((response) => {
            const body = response.data;

            this.reference = _.pick(body.data, [
              "content_title",
              "content",
              "attachments",
              "is_hidden",
              "formated_jalali_held_at",
            ]);
            this.reference.held_at = body.data.held_at
              ? Date.parse(body.data.held_at)
              : Date.now(); //isodate to timestamp
            if (
              Array.isArray(body.data.attachments) &&
              body.data.attachments.length > 0 &&
              Array.isArray(body.data.attachment_urls) &&
              body.data.attachment_urls
            ) {
              this.attachmentFiles = [];
              for (let n = 0; n < body.data.attachments.length; n++) {
                const attachment = body.data.attachments[n];
                this.attachmentFiles.push({
                  originalName: attachment.original_name || attachment.name,
                  desc: `نام: ${attachment.original_name || attachment.name}`,
                  url: body.data.attachment_urls[n],
                  self: attachment.name,
                  mimeType: attachment.mimeType,
                });
              }
            }
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    formatReferenceHeldAt() {
      return this.reference &&
        this.reference.held_at &&
        !this.isAdd &&
        this.reference.held_at != Date.now()
        ? momentJalaali(this.reference.held_at).format("jYYYY/jM/jD")
        : "تاریخی انتخاب نشده است";
    },
    uploadReferenceDetailFile() {
      if (this.referenceDetailFile == null) {
        return;
      }
      this.loading = true;
      this.$bvToast.toast("کمی صبر کنید", {
        variant: "info",
        title: "در حال آپلود فایل",
      });

      let formData = new FormData();
      formData.append("file", this.referenceDetailFile[0]);

      this.axios.post(`/references/upload-content?referenceId=${this.reference_id}`, formData)
        .then(() => {
          this.$bvToast.toast("متن منبع با موفقیت ثبت شد", {
            variant: "success",
            title: "هورا",
          });
          this.loadPage();
        })
    },
    uploadAttachmentFiles() {
      if (this.inputAttachmentFiles.length <= 0) {
        return;
      }
      this.loading = true;
      this.$bvToast.toast("کمی صبر کنید", {
        variant: "info",
        title: "در حال آپلود فایل",
      });
      this.inputAttachmentFiles.forEach((inputAttachmentFile) => {
        this.attachmentFiles.push({
          originalName: inputAttachmentFile.name,
          desc: `نام: ${inputAttachmentFile.name}، حجم: ${humanize.filesize(
            inputAttachmentFile.size
          )}`,
          url: null,
          self: null,
          mimeType: inputAttachmentFile.type,
        });
      });

      for (let n = 0; n < this.inputAttachmentFiles.length; n++) {
        const inputAttachmentFile = this.inputAttachmentFiles[n];

        let formData = new FormData();
        formData.append("file", inputAttachmentFile);

        this.$axios
          .post("/uploads/reference-attachments", formData)
          .then((response) => {
            const body = response.data;

            for (let i = 0; i < this.attachmentFiles.length; i++) {
              const imageFile = this.attachmentFiles[i];
              if (
                imageFile.originalName == body.data.requested_file_original_name
              ) {
                this.attachmentFiles[i]["url"] = body.data.file_url;
                this.attachmentFiles[i]["self"] = body.data.file;
              }
            }
            this.$bvToast.toast("فایل ضمیمه با موفقیت آپلود شد", {
              variant: "success",
              title: "هورا",
            });
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
            _.remove(this.attachmentFiles, (afElem) =>
              _.map(this.inputAttachmentFiles, "name").includes(
                afElem.originalName
              )
            );
          })
          .finally(() => {
            this.loading = false;
            this.inputAttachmentFiles = [];
          });
      }
    },
    dropAttachment(index) {
      _.pullAt(this.attachmentFiles, [index]);
      this.attachmentFilesKey += 1;
    },
    doRemove() {
      this.$bvModal
        .msgBoxConfirm(
          "آیا از حذف " + this.reference.content_title + " اطمینان دارید؟",
          {
            title: "توجه",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "بله",
            cancelTitle: "بستن",
            bodyClass: "text-right",
            headerClass: "text-danger",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((result) => {
          if (result) {
            this.loading = true;
            this.$axios
              .delete("/references/" + this.reference_id)
              .then(() => {
                this.$bvToast.toast("منبع با موفقیت حذف شد", {
                  variant: "success",
                  title: "هورا",
                });
                setTimeout(() => {
                  this.$router.go(this.homeIndex);
                }, 1000);
              })
              .catch((err) => {
                this.$bvToast.toast(err.text, {
                  variant: "danger",
                  title: "خطا",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    doAddOrEdit() {
      if (this.reference.content_title == "" || !this.reference.content_title) {
        return this.$bvToast.toast("فیلد عنوان الزامی است", {
          variant: "danger",
          title: "خطا",
        });
      }

      if (!this.reference.held_at) {
        return this.$bvToast.toast("فیلد تاریخ برگزاری الزامی است", {
          variant: "danger",
          title: "خطا",
        });
      }

      if (
        this.attachmentFiles &&
        Array.isArray(this.attachmentFiles) &&
        this.attachmentFiles.length > 0
      ) {
        this.reference.attachments = _.map(
          this.attachmentFiles,
          (attachmentFile) => {
            if (attachmentFile.self) {
              return {
                name: attachmentFile.self,
                mimetype: attachmentFile.mimeType,
                original_name: attachmentFile.originalName,
              };
            }
          }
        );
      }

      this.loading = true;
      if (this.isAdd) {
        this.$axios
          .post("/references", this.reference)
          .then((response) => {
            if (response.status == 208) {
              //means duplicate content
              const body = response.data;
              this.$bvToast.toast(
                "منبع فوق تکراری است، می توانید آن را ویرایش کنید",
                {
                  variant: "warning",
                  title: "توجه",
                  href: this.$router.resolve({
                    name: "EditReference",
                    params: { reference_id: body.data._id },
                    query: { home_index: -2 },
                  }).href,
                }
              );
            } else {
              this.$bvToast.toast("منبع با موفقیت ایجاد شد", {
                variant: "success",
                title: "هورا",
              });
              this.$router.go(this.homeIndex);
            }
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$axios
          .put("/references/" + this.reference_id, this.reference)
          .then((response) => {
            if (response.status == 208) {
              //means duplicate content
              const body = response.data;
              this.$bvToast.toast(
                "منبع فوق تکراری است، می توانید آن را ویرایش کنید",
                {
                  variant: "warning",
                  title: "هورا",
                  href: this.$router.resolve({
                    name: "EditReference",
                    params: { reference_id: body.data._id },
                    query: { home_index: -2 },
                  }).href,
                }
              );
            } else {
              this.$bvToast.toast("منبع با موفقیت ویرایش شد", {
                variant: "success",
                title: "هورا",
              });
              this.$router.go(this.homeIndex);
            }
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>